import { render } from "./Out_garbage.vue?vue&type=template&id=84cfa644&scoped=true"
import script from "./Out_garbage.vue?vue&type=script&lang=js"
export * from "./Out_garbage.vue?vue&type=script&lang=js"

import "./Out_garbage.vue?vue&type=style&index=0&id=84cfa644&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84cfa644"]])

export default __exports__